// Mock records are opt-in for prototype/demo builds. Live UAT and mobile builds
// must keep API empty/error states truthful.
export const MOCK_DATA_ENABLED = (import.meta as any).env?.VITE_ENABLE_MOCK_DATA === "true";
